import React, { useLayoutEffect, useState } from 'react';
import { observer } from 'mobx-react';
import { FormattedMessage, useIntl } from 'react-intl';
import * as mobx from 'mobx';
import { CommonModal } from '../../../../../../../../../global/modal/common/common-modal';
import { FormField } from '../../../../../../../../../global/form/form-field/form-field';
import DefaultButton from '../../../../../../../../../global/default-button/default-button';
import { ADD_TEXT, CANCEL_TEXT } from '../../../../../../../../../../constants/common-labels.constants';
import { ADD_ORGANIZATION_MODAL_TITLE_TEXT, ORGANIZATION_NAME_TEXT } from '../../../../../../../../event-hubs.text';
import { SpeakerOrganizationFormVM } from './speaker-organization-form.viewmodel';
import { NAME } from './speaker-organization-form.config';
import './speaker-organization-form-modal.scss';

type SpeakerOrganizationFormPresentationProps = {
    vm: SpeakerOrganizationFormVM;
};

const MIN_MARGIN_TOP = 20;

const SpeakerOrganizationFormPresentation: React.FC<SpeakerOrganizationFormPresentationProps> = observer(({ vm }) => {
    const { formatMessage } = useIntl();
    const nameField = vm.getFormVmValuePropsByKey(NAME);
    const [ownElement, setOwnElement] = useState<HTMLDivElement | null>(null);

    useLayoutEffect(() => {
        const anchorElement = vm.getAnchorElement();
        if (!anchorElement || !ownElement) return;

        const anchorRect = anchorElement.getBoundingClientRect();
        const ownRect = ownElement.getBoundingClientRect();
        const anchorCenterY = anchorRect.top + anchorRect.height / 2;

        ownElement.style.marginTop = `${Math.max(MIN_MARGIN_TOP, anchorCenterY - ownRect.height / 2)}px`;
    }, [ownElement]);

    return (
        <CommonModal
            isOpen
            keepPreviousModalVisible
            title={<FormattedMessage {...ADD_ORGANIZATION_MODAL_TITLE_TEXT} />}
            onRequestClose={vm.isSaving ? undefined : vm.cancel}
            className='speaker-organization-form-modal'
            contentRef={setOwnElement}
            footer={
                <div
                    className='speaker-organization-form-modal__footer'
                    onMouseDown={event => event.preventDefault()}
                >
                    <DefaultButton modifier='cancel' text={<FormattedMessage {...CANCEL_TEXT} />} onClick={vm.cancel} disabled={vm.isSaving} />
                    <DefaultButton text={<FormattedMessage {...ADD_TEXT} />} onClick={vm.submit} disabled={vm.isSaving} />
                </div>
            }
        >
            <div className='speaker-organization-form-modal__body'>
                <FormField label={<FormattedMessage {...ORGANIZATION_NAME_TEXT} />}>
                    <input
                        className='oe-form-field__control'
                        value={nameField.value as string}
                        onChange={mobx.action(({ target: { value } }) => {
                            vm.clearServerError();
                            nameField.setValue(value);
                        })}
                        onBlur={nameField.setTouched}
                    />
                    {nameField.touched && !nameField.valid &&
                        <span className='oe-form-field__error'>
                            <FormattedMessage
                                values={{ fieldName: formatMessage(ORGANIZATION_NAME_TEXT) }}
                                {...nameField.validationMessage}
                            />
                        </span>}
                    {vm.serverErrorMessage &&
                        <div className='oe-form-field__error'>{vm.serverErrorMessage}</div>}
                </FormField>
            </div>
        </CommonModal>
    );
});

export { SpeakerOrganizationFormPresentation };